// ** PTZ DETECTION
const initialState = {
  ptzDetection: false,
  ptzDetectionHistory: false
}

const ptzDetection = (state = initialState, action) => {
  switch (action.type) {
    case "PTZ_DETECTION":
      return { ...state, ptzDetection: action.val }
    case "PTZ_DETECTION_HISTORY":
      return { ...state, ptzDetectionHistory: action.val }
    default:
      return state
  }
}

export default ptzDetection
